<template>
  <div class="all-whole">
    <navCom :navActive="navActive"></navCom>
    <div class="w clearfix">
      <!--左侧导航 start-->
      <user-nav :userNav="userNav"></user-nav>
      <!--左侧导航 end-->
      <!--右侧内容 start-->
      <div class="user-main-right">
        <h3 class="info-title">基础资料</h3>
        <div class="info-modify">
          <div class="info-modify-div">
            <span class="info-modify-txt">头像：</span>
            <div class="head_img">
              <div class="default-head">
                <img :src="avatar"/>
              </div>
                <form ref="form" enctype="multipart/form-data">
                  <a href="javascript:;" class="syy-file">点击上传
                    <input type="file" accept="image/*" @change="handleFile" name="file" >
                  </a>
                </form>

            </div>
          </div>
          <div class="info-modify-div">
            <span class="info-modify-txt">昵称：</span>
            <div class="nickname">
              <input type="text" class="nickname-input" v-model="nickname">
            </div>
          </div>
          <div class="info-modify-div">
            <span class="info-modify-txt">性别：</span>
            <div class="gender">
              <div class="input-select">
                <div class="input-select-div">
                  <input id="item1" type="radio" name="item" :checked="sex == '1'" @click="sexFun(1)">
                  <label for="item1"></label>
                  <span>男</span>
                </div>
                <div class="input-select-div">
                  <input id="item2" type="radio" name="item" value="女" :checked="sex == '2'" checked @click="sexFun(2)">
                  <label for="item2"></label>
                  <span>女</span>
                </div>
              </div>
            </div>
          </div>
          <div class="info-modify-div">
            <span class="info-modify-txt">真实姓名：</span>
            <div class="nickname">
              <input type="text" class="nickname-input"  onkeyup="value=value.replace(/[^\u4E00-\u9FA5]/g,'')" v-model="true_name">
            </div>
          </div>
          <div class="info-modify-div">
            <span class="info-modify-txt">身份证号：</span>
            <div class="nickname">
              <input type="text" class="nickname-input" v-model="id_card">
            </div>
          </div>
          <div class="info-modify-div">
            <span class="info-modify-txt">班次信息：</span>
            <div class="nickname">
              <input type="text" class="nickname-input" v-model="shift">
            </div>
          </div>
          <div class="info-modify-div">
            <span class="info-modify-txt">工种信息：</span>
            <div class="nickname">
              <input type="text" class="nickname-input" v-model="work_type">
            </div>
          </div>
          <div class="info-modify-div">
            <span class="info-modify-txt">城市：</span>
            <div class="drop-down-box">
              <div class="drop-down">
                <div class="drop-down-item" :class="{'active':selectShow == 1}">
                  <span @click="chooseCityFun">{{chooseCity.city == '' ? '==请选择==': chooseCity.city}}</span>
                  <i></i>
                  <div class="drop-down-choose" v-if="selectShow == 1">
                    <p @click="chooseCityTxtFun($event,reg.code)" v-for="(reg,num) in cityArr" :key="reg.code">{{reg.name}}</p>
                  </div>
                </div>
                <div class="drop-down-item" :class="{'active':selectShow == 2}">
                  <span @click="chooseRegionFun">{{chooseCity.region == '' ? '==请选择==': chooseCity.region}}</span>
                  <i></i>
                  <div class="drop-down-choose" v-if="selectShow == 2">
                    <p @click="chooseRegionTxtFun($event,reg.code)" v-for="(reg,num) in areaArr" :key="num">{{reg.name}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <span class="fill-inviter-inner-btn" @click="postUserInfo()">保存设置</span>
      </div>
      <!--右侧内容 end-->
    </div>
    <footerCom></footerCom>
  </div>
</template>

<script>
  import defaultHead from '../../../static/images/syy-images/girl.png'
  import UserNav from '.././components/user-nav.vue'
  import navCom from '../../components/welcome-nav'
  import footerCom from '../../components/foot'
  import tool from '../../assets/tjs/tool'
  import axios from 'axios'
  export default {
    name: "user-info",
    components:{
      UserNav,
      navCom,
      footerCom
    },
    data () {
      return {
        navActive:3,
        userNav:1,
        showPic:true,
        avatar:defaultHead,
        userInfo: '',
        nickname: '', //昵称
        true_name: '', //真实姓名
        id_card:'',//身份证号
        sex: 1,
        cityArr: [], //城市数组
        areaArr: Array, //区域数组
        chooseCity: {
          city: '==请选择==',
          region: '==请选择==', //区域
          cityId: '',
          regionId:'',
        },
        selectShow: 0,
        cate_id: '',
        regionShow: false,
        cityShow: false,
        work_type:'',
        shift:'',
      }
    },
    methods: {
      uploadHeadImg: function () {
        this.$el.querySelector('.hiddenInput').click()
      },
      // 将头像显示
      handleFile: function (e) {
        let $target = e.target || e.srcElement;
        let file = $target.files[0];
        var reader = new FileReader();
        reader.onload = (data) => {
          let res = data.target || data.srcElement;
          this.avatar = res.result;
          this.showPic=false
        };
        reader.readAsDataURL(file);
        var formData = new FormData(this.$refs.form);
        axios.post('/api/Base/uploadPic', formData)
          .then(response => {
            this.imgid = response.data.url
          })
      },
      //性别选择
      sexFun (n) {
        this.sex = n;
      },
      //显示城市下拉框
      chooseCityFun () {
        this.cityShow = !this.cityShow;
        this.selectShow = 1;
      },
      //显示区域下拉框
      chooseRegionFun () {
        if(this.chooseCity.cityId == ''){
          this.$toast.center('请选择城市');
        }else{
          this.regionShow = !this.regionShow;
          this.selectShow = 2;
          var that=this;
          let data =  {
            user_id: that.$store.state.uuid,
            pcode :that.chooseCity.cityId
          };
          tool.postData('Center_User/getAreaInfo',data,(res)=>{
            that.areaArr = res.data;
          })
        }
      },
      //城市选择
      chooseCityTxtFun (e,id) {
        this.cityShow = false;
        this.selectShow = 0;
        this.chooseCity.city = e.target.innerHTML;
        this.chooseCity.cityId = id;
        this.chooseCity.region = '';
        this.chooseCity.regionId=''
      },
      //区域选择
      chooseRegionTxtFun (e,num) {
        this.regionShow = false;
        this.selectShow = 0;
        this.chooseCity.region = e.target.innerHTML;
        this.chooseCity.regionId = num
      },
      //提交按钮
      postUserInfo () {
        var that=this;
        that.selectShow=0;
        let data =  {
          user_id: that.$store.state.uuid,
          nickname: that.nickname,
          true_name: that.true_name,
          id_card:this.id_card,
          sex: that.sex,
          city_code: that.chooseCity.cityId,
          area_code: that.chooseCity.regionId,
          head_img:that.imgid,
          shift:this.shift,
          work_type:this.work_type
        };
        axios.post('/api/Center_User/editInfo' , data)
          .then(function (res) {
            /** 成功 : 1 **/
            if (res.data.code == 200) {
              that.$toast.center(res.data.msg);
            }
            /** 失败 : 0/3 **/
            else {
              /** 提示错误信息 : 0  **/
              if (res.data.code == 400) {
                that.$toast.center(res.data.msg);
              }
            }
          })
      },
      /* 获取cookie */
      getCookie: function (name) {
        var arr = document.cookie.match(new RegExp("(^| )"+name+"=([^;]*)(;|$)"));
        if(arr != null) {
          return unescape(arr[2]);
        }
        return null;
      },
      //信息获取
      getUserInfo () {
        let that=this;
        let data = {
          user_id : that.$store.state.uuid
        };
        tool.postData('Center_User/index',data,(res)=>{
          that.userInfo = res.data.user_info;
          that.nickname = that.userInfo.nickname;
          that.true_name = that.userInfo.true_name;
          that.id_card=that.userInfo.id_card;
          that.avatar = that.userInfo.head_img;
          if (that.userInfo.sex == '男') {
            that.sex = 1
          }else if (that.userInfo.sex == '女') {
            that.sex = 2
          }
          that.cityArr = res.data.city_info;
          that.areaArr = res.data.area_info;
          that.chooseCity.cityId = that.userInfo.city_code;
          that.chooseCity.regionId  = that.userInfo.area_code;
          console.log(that.cityArr )
          //获取城市
          res.data.city_info.forEach(v=>{
            if (res.data.user_info.city_code === v.code){
              that.chooseCity.city = v.name;
            }
          });
          that.shift = that.userInfo.shift;
          that.work_type = that.userInfo.work_type;
          let data =  {
            user_id: that.$store.state.uuid,
            pcode :that.chooseCity.cityId
          };
          tool.postData('Center_User/getAreaInfo',data,(res)=>{
            that.areaArr = res.data;
            res.data.forEach(v=>{
              tool.postData('Center_User/index',data,(res)=> {
                if (res.data.user_info.area_code === v.code) {
                  that.chooseCity.region = v.name;
                }
              });
            })
          })
        })
      }
    },

    mounted() {
      this.getUserInfo();
    },
  }
</script>

<style scoped>
  .w{
    width: 1200px;
    margin: 0 auto ;
  }
  .all-whole{
    background: #fbfbfb;
  }
  .user-main-right{
    width: 1000px;
    float: right;
    height: auto;
    background: #ffffff;
    padding-bottom: 30px;
  }
  .info-title{
    width: 100%;
    height: 70px;
    line-height: 100px;
    box-sizing: border-box;
    border-bottom: 1px solid #e3e3e3;
    font-size: 18px;
    color: #252525;
    padding-left: 20px;
    font-weight: 500;
  }
  .info-modify-div{
    margin-top: 25px;
  }
  .info-modify-txt{
    color: #6c6c6c;
    font-size: 16px;
    width: 160px;
    display: inline-block;
    text-align: right;
    position: relative;
  }
  .head_img{
    display: inline-block;
    position: relative;
    vertical-align: middle;
  }
  .default-head{
    width: 88px;
    height: 88px;
    border-radius: 50%;
    overflow: hidden;
  }
  .default-head img{
    width: 100%;
    height: 100%;
  }
  .default-head-info-black{
    position: absolute;
    top: 0;
    left: 0;
    width: 88px;
    height: 88px;
    border-radius: 50%;
    overflow: hidden;
    background: rgba(0,0,0,.2);
  }
  .default-head-info p{
    font-size: 14px;
    color: #fff;
    line-height: 88px;
    text-align: center;
  }
  .default-head-info input{
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    width: 88px;
    height: 88px;
    cursor: pointer;
  }

  .nickname{
    width: 308px;
    height: 35px;
    display: inline-block;
  }
  .nickname-input{
    width: 308px;
    height: 35px;
    border: 1px solid #e3e3e3;
    font-size: 14px;
    color: #6c6c6c;
    padding-left: 10px;
    box-sizing: border-box;
  }

  .gender{
    display: inline-block;
  }
  .input-select-div {
    position: relative;
    line-height: 30px;
    display: inline-block;
    margin-right: 23px;
  }
  .input-select-div input[type="radio"],.input-select-div input[type="checkbox"] {
    width: 20px;
    height: 20px;
    opacity: 0;
  }
  .input-select-div span{
    margin-left: 10px;
    color: #878787;
    font-size: 16px;
    font-weight: 500;
  }

  .input-select-div label {
    position: absolute;
    left: 5px;
    top: 6px;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    border: 1px solid #999;
  }
  .input-select-div .input-bg {
    background: #fff;
    border: 1px solid #fff;
  }

  /*设置选中的input的样式*/
  /* + 是兄弟选择器,获取选中后的label元素*/

  .input-select-div input:checked+label::after {
    position: absolute;
    content: "";
    width: 8px;
    height: 8px;
    top: 3px;
    left: 3px;
    background: #ff9911;
    border-radius: 50%;
  }
  .input-select-div input:checked+.input-bg[data-v-e56eb3da]::after {
    position: absolute;
    content: "";
    width: 9px;
    height: 4px;
    top: 0px;
    left: 3px;
    border: 2px solid transparent;
    border-left-color: #ff9919;
    border-bottom-color: #ff9919;
    transform: rotate(-50deg);
    background: transparent;
    border-radius: 0;
  }

  .drop-down-box{
    display: inline-block;
    width: 380px;
    vertical-align: middle;
  }
  .drop-down{
    width: 390px;
    display: flex;
    justify-content: space-between;
  }
  .drop-down-item{
    width: 190px;
    height: 35px;
    border: 1px solid #e3e3e3;
    position: relative;
  }
  .drop-down-item.active{
    border: 1px solid #1a71ff;
  }
  .grade-item{
    width: 100%;
    outline: none;
  }
  .drop-down-item span{
    line-height: 35px;
    color: #6c6c6c;
    font-size: 14px;
    padding-left: 5px;
    box-sizing: border-box;
    width: 175px;
    display: inline-block;
    cursor: pointer;
  }
  .grade-item span{
    width: 289px;
    height: 32px;
  }
  .drop-down-item i{
    border: 6px solid transparent;
    border-top-color: #bfbfbf;
    vertical-align: bottom;
    position: relative;
    top: 2px;
  }
  .drop-down-choose{
    position: absolute;
    left: 0;
    top: 45px;
    width: 100%;
    height: 264px;
    border: 1px solid #e3e3e3;
    border-radius: 6px;
    z-index: 1;
    background: #fff;
    overflow-y: auto;
  }
  .drop-down-choose p{
    line-height: 35px;
    font-size: 14px;
    color: #6c6c6c;
    padding-left: 5px;
    box-sizing: border-box;
    cursor: pointer;
  }
  .drop-down-choose p:hover{
    background: #e3e3e3;
  }
  .fill-inviter-inner-btn{
    width: 313px;
    height: 54px;
    background: #1a71ff;
    color: #fff;
    font-size: 16px;
    display: block;
    margin: 45px 0 0 166px;
    text-align: center;
    line-height: 54px;
    cursor: pointer;
  }
  .syy-i{
    color: #ff0000;
    padding-right: 7px;
    position: absolute;
    top: 5px;
    right: 48px;
  }
  /*修改头像 点击上传按钮的样式*/
  .syy-file {
    position: relative;
    display: inline-block;
    border: 1px solid #999999;
    border-radius: 4px;
    padding: 4px 12px;
    overflow: hidden;
    color: #999999;
    text-decoration: none;
    text-indent: 0;
    line-height: 15px;
    margin-top: 20px;
    margin-left: 7px;
  }
  .syy-file input {
    position: absolute;
    font-size: 100px;
    right: 0;
    top: 0;
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/user-info.vue